import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../../core/Error.js";
import e from "../../../../core/Logger.js";
import { isSome as r, isNone as s } from "../../../../core/maybe.js";
import { c as i } from "../../../../chunks/mat3f32.js";
import { DisplayObject as o } from "../DisplayObject.js";
import h from "./Mesh2D.js";
import a from "../../../webgl/VertexArrayObject.js";

var c = e.getLogger("esri.views.2d.engine.webgl.ClippingInfo"),
    n = function n(t) {
  return parseFloat(t) / 100;
};

var m = /*#__PURE__*/function (_o) {
  _inherits(m, _o);

  var _super = _createSuper(m);

  function m(t, e) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this), _this._clip = e, _this._cache = {}, _this.stage = t, _this._handle = e.watch("version", function () {
      return _this._invalidate();
    }), _this.ready();
    return _this;
  }

  _createClass(m, [{
    key: "_destroyGL",
    value: function _destroyGL() {
      r(this._cache.mesh) && (this._cache.mesh.destroy(), this._cache.mesh = null), r(this._cache.vao) && (this._cache.vao.dispose(), this._cache.vao = null);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroyGL(), this._handle.remove();
    }
  }, {
    key: "getVAO",
    value: function getVAO(t, e, r, i) {
      var _e$size = _slicedToArray(e.size, 2),
          o = _e$size[0],
          h = _e$size[1];

      if ("geometry" !== this._clip.type && this._lastWidth === o && this._lastHeight === h || (this._lastWidth = o, this._lastHeight = h, this._destroyGL()), s(this._cache.vao)) {
        var _s = this._createMesh(e, this._clip),
            _o2 = _s.getIndexBuffer(t),
            _h = _s.getVertexBuffers(t);

        this._cache.mesh = _s, this._cache.vao = new a(t, r, i, _h, _o2);
      }

      return this._cache.vao;
    }
  }, {
    key: "_createTransforms",
    value: function _createTransforms() {
      return {
        dvs: i()
      };
    }
  }, {
    key: "_invalidate",
    value: function _invalidate() {
      this._destroyGL(), this.requestRender();
    }
  }, {
    key: "_createScreenRect",
    value: function _createScreenRect(t, e) {
      var _t$size = _slicedToArray(t.size, 2),
          r = _t$size[0],
          s = _t$size[1],
          i = "string" == typeof e.left ? n(e.left) * r : e.left,
          o = "string" == typeof e.right ? n(e.right) * r : e.right,
          h = "string" == typeof e.top ? n(e.top) * s : e.top,
          a = "string" == typeof e.bottom ? n(e.bottom) * s : e.bottom,
          c = i,
          _m = h;

      return {
        x: c,
        y: _m,
        width: Math.max(r - o - c, 0),
        height: Math.max(s - a - _m, 0)
      };
    }
  }, {
    key: "_createMesh",
    value: function _createMesh(e, r) {
      switch (r.type) {
        case "rect":
          return h.fromRect(this._createScreenRect(e, r));

        case "path":
          return h.fromPath(r);

        case "geometry":
          return h.fromGeometry(e, r);

        default:
          return c.error(new t("mapview-bad-type", "Unable to create ClippingInfo mesh from clip of type: ${clip.type}")), h.fromRect({
            x: 0,
            y: 0,
            width: 1,
            height: 1
          });
      }
    }
  }], [{
    key: "fromClipArea",
    value: function fromClipArea(t, e) {
      return new m(t, e);
    }
  }]);

  return m;
}(o);

export { m as default };